module.exports = __webpack_public_path__ + "static/img/IAN_CHAPPELL.17d035e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IAN_CHAPPELL.jpg
// module id = J3qN
// module chunks = 0